import React from "react";
import { cn } from "../utils";
import edit from "../assets/images/icon/edit.png";
import view from "../assets/images/icon/eye-scan.png";
import Pagination from "./Pagination";

const Table = React.forwardRef(
  (
    {
      style,
      containerStyle,
      headers,
      data,
      className,
      handleView,
      showPagination = true,
      containerClassName = "",
      ...rest
    },
    ref
  ) => {
    return (
      <>
        <div
          className={cn("table-container", containerClassName)}
          style={{ ...containerStyle }}
        >
          <table
            ref={ref}
            className={cn("table custom-table", className)}
            {...rest}
          >
            <thead>
              <tr>
                {headers.map((header, index) => {
                  return (
                    <th key={cn(header?.headerName, String(index))}>
                      {header?.headerName}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((d, index) => {
                return (
                  <tr key={index} className="table-data-row">
                    {headers.map((header, index) => {
                      const value = d?.[header?.key];
                      return (
                        <td
                          key={cn(value, String(index))}
                          className="table-data"
                        >
                          {header?.renderValue ? (
                            header?.renderValue(d)
                          ) : (
                            <>
                              {header.key !== "action" ? (
                                <span
                                  className={
                                    header?.key === "active_status"
                                      ? "active"
                                      : header?.key === "onboard_status"
                                      ? value === "Completed"
                                        ? "complete"
                                        : value === "Need Attention"
                                        ? "need-attention"
                                        : ""
                                      : ""
                                  }
                                >
                                  {value}
                                </span>
                              ) : (
                                <div className="d-flex gap-4">
                                  <img
                                    src={edit}
                                    alt="Edit"
                                    style={{ cursor: "pointer" }}
                                  />
                                  <img
                                    src={view}
                                    alt="View"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleView(d)}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {showPagination && (
          <Pagination
            style={{
              marginTop: "14px",
            }}
          />
        )}
      </>
    );
  }
);

Table.displayName = "Table";

export default Table;
